import { useMemo } from "react";
import PDFDownloadButton from "../reuseableComponents/PDFDownloadButton";

const DownloadWaterSystemReports = ({ activeTab, selectedWaterSystem }) => {
  const pdfConfig = useMemo(() => {
    if (!selectedWaterSystem || Object.keys(selectedWaterSystem).length === 0) {
      return null;
    }

    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleDateString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric'
    });
    const formattedTime = currentDate.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });

    const searchParams = new URLSearchParams();
    searchParams.set('tab', activeTab);
    searchParams.set('pwsId', selectedWaterSystem.pwsId);

    return {
      filename: `${activeTab}-report-${selectedWaterSystem.pwsId}.pdf`,
      printableUrl: `${window.location.origin}/reports/${activeTab}?${searchParams.toString()}`,
      footer: {
        text: `Run Date: ${formattedDate} ${formattedTime} | Rating: ${selectedWaterSystem.rating?.rating || 'N/A'} | ${selectedWaterSystem.pwsId || ''} ${selectedWaterSystem.systemName || ''}`
      }
    };
  }, [activeTab, selectedWaterSystem]);

  return (
    <div className="download-water-system-reports">
      <PDFDownloadButton
        filename={pdfConfig?.filename}
        printableUrl={pdfConfig?.printableUrl}
        footer={pdfConfig?.footer}
        disabled={!pdfConfig}
      />
    </div>
  );
};

export default DownloadWaterSystemReports;